import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { CalendarEdit } from 'iconsax-react'
import { forwardRef, useState } from 'react'
import { SelectSingleEventHandler, DayPickerProps } from 'react-day-picker'
import { Calendar } from './calendar'
import { Popover, PopoverContent, PopoverTrigger } from './popover'

type DatePickerProps = {
  label: string
  selected: any
  onChange: (date: Date) => void
} & Omit<DayPickerProps, 'mode' | 'selected' | 'onSelect'>

export const DatePicker = forwardRef<HTMLDivElement, DatePickerProps>(
  ({ label, selected, onChange }, ref) => {
    const [open, setOpen] = useState(false)

    const handleSelect: SelectSingleEventHandler = (date) => {
      setOpen(false)
      if (date) {
        onChange(date)
      }
    }

    return (
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger className="w-full">
          <div
            ref={ref}
            className="flex h-10 w-full items-center gap-2 rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
          >
            <CalendarEdit size={20} />
            <p>{selected ? format(selected as Date, 'dd/MM/yyyy') : label}</p>
          </div>
        </PopoverTrigger>
        <PopoverContent
          align="end"
          className="w-[346px] border bg-background p-0 shadow-lg"
        >
          <Calendar
            mode="single"
            defaultMonth={new Date()}
            locale={ptBR}
            onSelect={handleSelect}
            selected={selected as Date}
          />
        </PopoverContent>
      </Popover>
    )
  },
)

DatePicker.displayName = 'DatePicker'
